module.exports = __webpack_public_path__ + "static/media/spiky_dj_live_mix.f209233c.mp3";